export default class DateRangeDaysDuration
{

    constructor(start, end)
    {
        if ( ! (start instanceof window.moment) ) {
            start = window.moment(start);
        }
        if ( ! (end instanceof window.moment) ) {
            end = window.moment(end);
        }

        this.start = start.startOf('day')
        this.end = end.endOf('day');

    }

    getDuration()
    {
        return this.end.diff(this.start, 'days');
    }

    isToday()
    {
        return this.start.isSame(window.moment(), 'day');
    }

    getDurationPassed()
    {
        let days = window.moment().diff(this.start, 'days');
        return days > this.getDuration()
            ? this.getDuration()
            : days;
    }

    getPercentage()
    {
        if ( this.isToday() ) {
            return 1;
        }
        
        let total = this.getDuration();
        let passed = this.getDurationPassed();

        if ( passed >= total ) {
            return 100;
        }

        if ( passed <= 0 ) {
            return 0;
        }


        return (100 * passed) / total;
    }

}